import { VALUE_TYPE } from "Components/NumberValue";
import { getPriceFormatFromValue } from "Formatting/index";
import { isDefined } from "Utils/functions";

export const getSliderInputValue = (
  valueType: VALUE_TYPE,
  initialValue: number,
  definedValue?: number,
): string => {
  if (isDefined(definedValue)) {
    return getPriceFormatFromValue(definedValue, valueType);
  }
  return getPriceFormatFromValue(initialValue, valueType);
};

export const isSliderValueWithinRange = (
  value: number,
  minSum: number,
  maxSum: number,
): boolean => {
  return value >= minSum && value <= maxSum;
};

export const isSliderValueValid = (
  value: number,
  minSum: number,
  maxSum: number,
  step?: number,
): boolean => {
  if (isSliderValueWithinRange(value, minSum, maxSum)) {
    if (isDefined(step)) {
      return isSliderValueValidStep(value, step);
    } else {
      return true;
    }
  }
  return false;
};

export const isSliderValueValidStep = (value: number, step: number): boolean =>
  value % step === 0;
